import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Col, Row } from "components/bootstrap";
import useUserDateTime from "hooks/useUserDateTime";
import TimeRangeTabs, { timeRangePickerTabs } from "./TimeRangePickerTabs";
import TimeRangePresetRow from "./TimeRangePresetRow";
export const allTimeRangeTypes = Object.keys(timeRangePickerTabs);
const Timezone = styled.p(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
    padding-left: 3px;
    margin: 0;
    min-height: 34px;
    display: flex;
    align-items: center;
  `
);
const TimeRangePickerFormContent = ({ children = void 0, validTypes = allTimeRangeTypes, limitDuration }) => {
  const { t } = useTranslation("search");
  const { userTimezone } = useUserDateTime();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(TimeRangePresetRow, { limitDuration }), /* @__PURE__ */ React.createElement(TimeRangeTabs, { limitDuration, validTypes }))), /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(Timezone, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "time_range.timezones_using",
      values: { timezone: userTimezone },
      components: { bold: /* @__PURE__ */ React.createElement("b", null) }
    }
  ))), /* @__PURE__ */ React.createElement(Col, { md: 6 }, children)));
};
export default TimeRangePickerFormContent;
